import { ModuleLayout } from "../_shared/ModuleLayout";
export default function LaunchLayout() {
  return (
    <ModuleLayout
      testId="pureh-launch"
      eyebrow="Launch · Studio"
      title="Launch Operating System"
      subtitle="Every launch, orchestrated: brief → pre-order → public → post-launch."
      tabs={[
        { to: "overview",    label: "Overview" },
        { to: "control",     label: "Launch Control" },
        { to: "checklist",   label: "Checklist" },
        { to: "preorders",   label: "Pre-Orders" },
        { to: "campaigns",   label: "Pre-Launch Campaigns" },
        { to: "subscribers", label: "Subscribers" },
      ]}
    />
  );
}
